import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IInitialState {
    deletedAvatarsIdList: string[] | null;
}

const initialState: IInitialState = {
    deletedAvatarsIdList: null,
};

const deletedAvatarIdSlice = createSlice({
    name: 'deletedAvatarId',
    initialState,
    reducers: {
        saveDeletedAvatarId: (state: IInitialState, action: PayloadAction<string>) => {
            if (!state.deletedAvatarsIdList?.includes(action.payload)) {
                state.deletedAvatarsIdList = [...(state.deletedAvatarsIdList || []), action.payload];
            }
        },

        removeDeletedAvatarId: (state: IInitialState) => {
            state.deletedAvatarsIdList = null;
        },
    },
});

export default deletedAvatarIdSlice.reducer;
export const { saveDeletedAvatarId, removeDeletedAvatarId } = deletedAvatarIdSlice.actions;
